export default {
  salesTrackingGeneral: [],

  //Supplier Stats
  suppliersStats: [],
  supplierCombinedStats: [],
  supplierMonthStats: [],
  specificSupplierStats: [],
  supplierSalesEnquiryBuyerTypeStats: [],
  supplierGoodCauseCCStats: [],
  supplierLeadsBuyerTypeStats: [],

  // Good Cause Stats
  specificGoodCauseStats: [],
  goodCauseSupplierCategoryCCStats: [],
  goodCauseSalesEnquiryBuyerTypeStats: [],
  goodCauseLeadsBuyerTypeStats: [],

  // Impact Buyer Stats
  specificBuyerStats: [],
  impactBuyerChosenGoodCause: {},
};
